export class FetchResponseError extends Error {
  constructor(public reason: string, public response: Response) {
    super(reason)
  }
}
